<template>
  <div class="page" v-loading="listLoading">
    <el-form @submit.native.prevent label-width="100px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="订单号:">
            <el-input v-model="searchData.OrderNo" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="外部订单号:">
            <el-input v-model="searchData.OutOrderNo" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="类型">
            <el-select v-model="searchData.AfterSaleType" style="width: 100%;">
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="1" label="退款"></el-option>
              <el-option :value="2" label="退货"></el-option>
              <el-option :value="3" label="换货"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <div style="display: flex;">
          <el-button type="primary" @click="searchFun">筛选</el-button>
          <el-button @click="resetFun">重置</el-button>
          <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <!--      @selection-change="selectCurrentRow"-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%"
      border>
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column prop="resellerName" label="订单信息" width="420">
        <template slot-scope="scope">
          <div style="text-align:left;">
            <p><span class="mgr20">订单号：{{ scope.row.orderNo }}</span><span>分销商：{{ scope.row.resellerName }}</span></p>
            <p><span class="mgr20">商品信息：{{ scope.row.order.productId }}</span><span>外部订单号：{{ scope.row.outOrderNo
            }}</span></p>
            <p><span class="mgr20">购买数量：{{ scope.row.afterSaleQuantity }}</span><span>价格：{{ scope.row.afterSaleAmount
            }}</span></p>
            <p>
              <span>收货信息：{{ scope.row.afterSaleName }}{{ scope.row.afterSaleMobile }}{{
                  scope.row.order.receivingProviceName
              }}{{ scope.row.order.receivingCityName }}{{
    scope.row.order.receivingDistrictName
}}{{ scope.row.order.receivingStreetName }}{{
    scope.row.order.receivingAddress
}}</span>
            </p>
            <p><span class="mgr20">商品供应商：{{ scope.row.sourceName }}</span><span>金额合计：{{ scope.row.afterSaleAmount
            }}</span>
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="orderNo" label="类型" width="120" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.afterSaleType == 1">退款</span>
          <span v-if="scope.row.afterSaleType == 2">退货</span>
          <span v-if="scope.row.afterSaleType == 3">换货</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderNo" label="订单状态" width="120" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.order.status == 0">创建订单</span>
          <span v-if="scope.row.order.status == 1">支付成功</span>
          <span v-if="scope.row.order.status == 2">待发货</span>
          <span v-if="scope.row.order.status == 3">已发货</span>
          <span v-if="scope.row.order.status == 4">订单完成</span>
        </template>
      </el-table-column>
      <el-table-column prop="afterSaleQuantity" label="申请退换货数量" width="120" align="center"></el-table-column>
      <el-table-column prop="afterSaleAmount" label="申请退换货金额" width="120" align="center"></el-table-column>
      <el-table-column prop="reason" label="退换货原因" width="120" align="center"></el-table-column>
      <el-table-column prop="creationTime" label="申请时间" width="200" align="center"></el-table-column>
      <el-table-column width="300" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <!-- <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
                       @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}
            </el-button> -->
          <el-button size="mini" type="primary" v-if="isShowConfirm && scope.row.afterSaleStatus == 1"
            @click="confirmBtn(scope.row)">审核确认</el-button>
          <el-button size="mini" type="danger" v-if="isShowReject && scope.row.afterSaleStatus == 1"
            @click="rejectBtn(scope.row)">驳回</el-button>
          <el-button size="mini" type="success" v-if="isShowDetail && scope.row.afterSaleStatus != 1"
            @click="detailBtn(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
    </el-pagination>
  </div>
</template>

<script>
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar"
import {
  OrderAfterSaleGetAll,
  OrderAfterSaleReject,
  OrderAfterSaleUpdate,
} from '../../../api/api'

export default {
  components: { Toolbar },
  name: "Index",
  data() {
    return {
      isShowConfirm: false,
      isShowReject: false,
      isShowDetail: false,
      listLoading: false,
      total: 0,
      tableList: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      searchData: {
        skipCount: 0, //页码
        maxResultCount: 10, //页长
        OrderNo: null,
        OutOrderNo: null,
        AfterSaleType: null,
      },
      pageIndex: 1,
      pageSize: 10,
      value: '',
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      // const tableButtonList = buttonList.filter((item) => {
      //   return item.buttonShow === 20;
      // });
      // this.buttonList_table = tableButtonList;
      console.log(buttonList)
      buttonList.forEach(item => {
        if (item.buttonFunc == 'confirmBtn') {
          this.isShowConfirm = true
        }
        if (item.buttonFunc == 'rejectBtn') {
          this.isShowReject = true
        }
        if (item.buttonFunc == 'detailBtn') {
          this.isShowDetail = true
        }
      })
    }
  },
  created() {
    this.getTableList();
  },
  methods: {
    detailBtn(row) {
      let type = row.afterSaleType;
      if (type === 1) {
        this.$router.push(`/AfterSalesService/RefoundMoney/AfterSaleDetail?Id=${row.id}&orderId=${row.orderId}`);
      } else if (type === 2) {
        this.$router.push(`/AfterSalesService/RefoundProduct/Detail?id=${row.id}&orderId=${row.orderId}`);
      } else if (type === 3) {
        this.$router.push(`/AfterSalesService/ExchangeGoods/AfterSaleDetail?id=${row.id}&orderId=${row.orderId}`);
      }
    },
    rejectBtn(row) {
      this.$confirm("确认驳回吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        let params = {};
        let res = await OrderAfterSaleReject({ id: row.id })
        console.log(row);
        if (res.data.success) {
          this.$message.success(res.data.msg || '保存成功');
        } else {
          this.$message.error(res.data.error.message || '保存失败, 请重试');
        }
      }).catch(() => {
      });

    },
    confirmBtn(row) {
      console.log('审核确认', row, row.afterSaleType);
      let type = row.afterSaleType;
      if (type === 1) {
        this.$router.push(`/AfterSalesService/Check/BackMoney?id=${row.id}&orderid=${row.orderId}`);
      } else if (type === 2) {
        this.$router.push(`/AfterSalesService/Check/BackProduct?id=${row.id}&orderid=${row.orderId}`);
      } else if (type === 3) {
        this.$router.push(`/AfterSalesService/Check/ExchangeProduct?id=${row.id}&orderid=${row.orderId}`);
      }
    },
    searchFun() {
      this.searchData.pageIndex = 1;
      this.getTableList();
    },
    resetFun() {
      this.searchData = {
        skipCount: 0, //页码
        maxResultCount: 10, //页长
        OrderNo: null,
        OutOrderNo: null,
        AfterSaleType: null,
      }
      this.pageIndex = 1
      this.pageSize = 10
      this.getTableList();
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getTableList()
    },
    getTableList() {
      this.listLoading = true
      this.searchData.skipCount = (this.pageIndex - 1) * this.pageSize
      this.searchData.maxResultCount = this.pageSize
      OrderAfterSaleGetAll(this.searchData).then(res => {
        if (res.data.success) {
          this.tableList = res.data.result.items
          this.total = res.data.result.totalCount
        } else {
          this.$message.error(res.data.error.message)
        }
        setTimeout(() => {
          this.listLoading = false
        }, 500)
      })
    }
  }
}
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mgr20 {
  margin-right: 20px;
}
</style>
